<template>
    <div id="message-component">
        <div v-for="(data, index) in toasts" :key="index + 'e'">
            <v-card
                :color="data.type === 'error' ? 'red lighten-2' : data.type"
                dark
                v-if="index < total"
                @click.stop="click(data)"
                class="message-component-card ma-2">
                <v-progress-linear
                    v-if="!data.clicked && data.time < 100"
                    color="blue-grey"
                    class="pa-0 ma-0"
                    height="4"
                    :value="data.time">
                </v-progress-linear>
                <v-layout justify-center align-center class="pa-3">
                    <v-icon class="mr-2" v-if="data.type === 'error'">mdi-alert-circle-outline</v-icon>
                    <v-icon class="mr-2" v-if="data.type === 'success'">mdi-check</v-icon>
                    <div class="message-component-message" style="width: 80%; word-wrap: break-word" v-html="data.message"></div>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="remove(index)">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card>
        </div>
    </div>
</template>

<style>
    #message-component {
        top : 0;
        right : 0;
        position : fixed;
        z-index : 2100;
    }
    #message-component .message-component-card {
        width : 80vw;
        max-width : 480px;
    }
    #message-component .message-component-card a {
        margin: 0 5px;
        color: gold;
    }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    data() {
        return {
            total: 3,
            interval: setInterval(this.update, 100)
        }
    },
    computed: {
        ...mapGetters({
            toasts: 'message/toasts'
        })
    },
    methods: {
        ...mapMutations({
            clear: 'message/collection'
        }),
        click(toast) {
            toast.clicked = true
        },
        remove(index) {
            this.toasts[index].remove = true
            this.clear()
        },
        update() {
            let clear = false
            let length = this.toasts.length
            for (let i = 0; i < length; i++) {
                let toast = this.toasts[i]
                if (toast.clicked) continue
                if (toast.time < 0) {
                    toast.remove = true
                    clear = true
                }
                if (i < this.total) {
                    toast.time -= 4
                }
            }
            if (clear) {
                this.clear()
            }
        }
    },
    destroyed() {
        clearInterval(this.interval)
    }
}
</script>
